// project import
import dashboard from './dashboard';
import clientes from './clientes';
import areaProduccion from './area-produccion';
import manufactura from './manufactura';
import agenda from './agenda';
import kanbanBoard from './kanban-board';
import kanbanIndividual from './kanban-individual';
import finanzas from './finanzas';
import catalogos from './catalogos';
import disenadorAudifono from './disenador-audifono';



// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [
    dashboard,
    clientes,
    ...areaProduccion,
    manufactura,
    agenda,
    kanbanBoard,
    kanbanIndividual,
    finanzas,
    catalogos,
    disenadorAudifono,
  ]
};

export default menuItems;
